import dayjs from 'dayjs';
import {MONTH_SHORT_DAY_YEAR_FORMAT} from '@/config/timeFormats';

function getDefaultProjectName(featureName: string) {
  return `${featureName} - ${dayjs().format(MONTH_SHORT_DAY_YEAR_FORMAT)}`;
}

export default getDefaultProjectName;
